import moment from 'moment';
import * as createNewJobTypes from './createNewJobActionTypes';

export const initialState = {
  appointmentsList: null,
  filters: {
    activeAppointStatuses: null,
    campuslId: null,
    date: moment().startOf('day'),
    practitionerId: null,
    selectedList: [],
  },
  info: {
    isManual: true,
    type: 'communicate', // ONLY FOR AZMONI
    runTime: null
  },
  specificDetails: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    //──── Clear all data ────────────────────────────────────────────────────────────────────
    case createNewJobTypes.CLEAR_NEW_JOB_DATA: {
      return initialState;
    }

    //──── Info ──────────────────────────────────────────────────────────────────────────────
    case createNewJobTypes.NEW_JOB_SET_INFO: {
      return { ...state, info: action.payload };
    }

    //──── Filters ───────────────────────────────────────────────────────────────────────────
    case createNewJobTypes.NEW_JOB_UPDATE_FILTERS: {
      return {
        ...state,
        filters: { ...state.filters, ...action.payload }
      };
    }

    //──── Appointments ──────────────────────────────────────────────────────────────────────
    case createNewJobTypes.NEW_JOB_SET_APPOINTMENTS: {
      return {
        ...state, appointmentsList: action.payload
      };
    }

    //──── Details ──────────────────────────────────────────────────────────────────────
    case createNewJobTypes.NEW_JOB_SET_DETAILS: {
      return {
        ...state, specificDetails: action.payload
      };
    }

    default:
      return state;
  }
};
